import {createAsyncThunk} from '@reduxjs/toolkit';
import BaseAPI from './BaseAPI';

export const fetchSatisfactionList = createAsyncThunk(
  'satisfaction/fetchSatisfactionList',
  async (
    {casePriority, surveyStatus: flgStatus, startTime, endTime},
    {getState, rejectWithValue},
  ) => {
    try {
      const token = getState().auth.token;
      const res = await BaseAPI.getWithAuth(
        '/satisfaction',
        {casePriority, flgStatus, startTime, endTime},
        token,
      );
      return res;
    } catch (error) {
      return rejectWithValue(res);
    }
  },
);

export const fetchSatisfaction = createAsyncThunk(
  'satisfaction/fetchSatisfaction',
  async (caseId, {getState, rejectWithValue}) => {
    try {
      const token = getState().auth.token;
      const res = await BaseAPI.getWithAuth(
        `/satisfaction/${caseId}`,
        null,
        token,
      );
      return res;
    } catch (error) {
      return rejectWithValue(res);
    }
  },
);

export const editSatisfaction = createAsyncThunk(
  'satisfaction/update',
  async (selectedSatisfactionData, {getState, rejectWithValue}) => {
    try {
      const token = getState().auth.token;
      const data = await BaseAPI.putWithAuth(
        `/cases/${selectedSatisfactionData.caseId}/satisfaction`,
        selectedSatisfactionData,
        token,
      );
      return data;
    } catch (error) {
      console.error('send notification error', error);
      rejectWithValue(error.response.data);
    }
  },
);
